import './App.css';
import Home from './pages/Home';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import HP from './pages/Toneri/HP';
import Kyocera from './pages/Toneri/Kyocera';
import Canon from './pages/Toneri/Canon';
import EF_37 from './components/Canon/CanonToneri/EF_37';
import FX_10 from './components/Canon/CanonToneri/FX_10';
import Canon3 from './components/Canon/CanonToneri/Canon3';
import Canon4 from './components/Canon/CanonToneri/Canon4';
import Canon5 from './components/Canon/CanonToneri/Canon5';
import Canon6 from './components/Canon/CanonToneri/Canon6';
import Canon7 from './components/Canon/CanonToneri/Canon7';
import Canon8 from './components/Canon/CanonToneri/Canon8';
import Canon9 from './components/Canon/CanonToneri/Canon9';
import Canon10 from './components/Canon/CanonToneri/Canon10';
import Brendovi from './pages/Brendovi';
import Samsung from './pages/Toneri/Samsung';
import Lexmark from './pages/Toneri/Lexmark';
import Xerox from './pages/Toneri/Xerox';
import Minolta from './pages/Toneri/Minolta';
import Epson from './pages/Toneri/Epson';
import Brother from './pages/Toneri/Brother';
import Panasonic from './pages/Toneri/Panasonic';

import Panasonic1 from './components/Panasonic/PanasonicToneri/Panasonic1';
import Panasonic2 from './components/Panasonic/PanasonicToneri/Panasonic2';
import Panasonic3 from './components/Panasonic/PanasonicToneri/Panasonic3';
import Panasonic4 from './components/Panasonic/PanasonicToneri/Panasonic4';
import Panasonic5 from './components/Panasonic/PanasonicToneri/Panasonic5';
import Panasonic6 from './components/Panasonic/PanasonicToneri/Panasonic6';
import Panasonic7 from './components/Panasonic/PanasonicToneri/Panasonic7';
import Panasonic8 from './components/Panasonic/PanasonicToneri/Panasonic8';
import Panasonic9 from './components/Panasonic/PanasonicToneri/Panasonic9';
import Panasonic10 from './components/Panasonic/PanasonicToneri/Panasonic10';
import Panasonic11 from './components/Panasonic/PanasonicToneri/Panasonic11';

import Brother1 from './components/Brother/BrotherToneri/Brother1';
import Brother2 from './components/Brother/BrotherToneri/Brother2';
import Brother3 from './components/Brother/BrotherToneri/Brother3';
import Brother4 from './components/Brother/BrotherToneri/Brother4';
import Brother5 from './components/Brother/BrotherToneri/Brother5';
import Brother6 from './components/Brother/BrotherToneri/Brother6';
import Brother7 from './components/Brother/BrotherToneri/Brother7';
import Brother8 from './components/Brother/BrotherToneri/Brother8';
import Brother9 from './components/Brother/BrotherToneri/Brother9';
import Brother10 from './components/Brother/BrotherToneri/Brother10';
import Brother11 from './components/Brother/BrotherToneri/Brother11';
import Brother12 from './components/Brother/BrotherToneri/Brother12';
import Brother13 from './components/Brother/BrotherToneri/Brother13';
import Brother14 from './components/Brother/BrotherToneri/Brother14';
import Brother15 from './components/Brother/BrotherToneri/Brother15';
import Brother16 from './components/Brother/BrotherToneri/Brother16';
import Brother17 from './components/Brother/BrotherToneri/Brother17';
import Brother18 from './components/Brother/BrotherToneri/Brother18';
import Brother19 from './components/Brother/BrotherToneri/Brother19';
import Brother20 from './components/Brother/BrotherToneri/Brother20';
import Brother21 from './components/Brother/BrotherToneri/Brother21';
import Brother22 from './components/Brother/BrotherToneri/Brother22';
import Brother23 from './components/Brother/BrotherToneri/Brother23';
import Brother24 from './components/Brother/BrotherToneri/Brother24';
import Brother25 from './components/Brother/BrotherToneri/Brother25';
import Brother26 from './components/Brother/BrotherToneri/Brother26';
import Brother27 from './components/Brother/BrotherToneri/Brother27';
import Brother28 from './components/Brother/BrotherToneri/Brother28';
import Brother29 from './components/Brother/BrotherToneri/Brother29';
import Brother30 from './components/Brother/BrotherToneri/Brother30';
import Brother31 from './components/Brother/BrotherToneri/Brother31';

import Epson1 from './components/Epson/EpsonToneri/Epson1';
import Epson2 from './components/Epson/EpsonToneri/Epson2';
import Epson3 from './components/Epson/EpsonToneri/Epson3';
import Epson4 from './components/Epson/EpsonToneri/Epson4';
import Epson5 from './components/Epson/EpsonToneri/Epson5';
import Epson6 from './components/Epson/EpsonToneri/Epson6';

import Minolta1 from './components/Minolta/MinoltaToneri/Minolta1';
import Minolta2 from './components/Minolta/MinoltaToneri/Minolta2';
import Minolta3 from './components/Minolta/MinoltaToneri/Minolta3';
import Minolta4 from './components/Minolta/MinoltaToneri/Minolta4';
import Minolta5 from './components/Minolta/MinoltaToneri/Minolta5';
import Minolta6 from './components/Minolta/MinoltaToneri/Minolta6';
import Minolta7 from './components/Minolta/MinoltaToneri/Minolta7';
import Minolta8 from './components/Minolta/MinoltaToneri/Minolta8';
import Minolta9 from './components/Minolta/MinoltaToneri/Minolta9';
import Minolta10 from './components/Minolta/MinoltaToneri/Minolta10';
import Minolta11 from './components/Minolta/MinoltaToneri/Minolta11';
import Minolta12 from './components/Minolta/MinoltaToneri/Minolta12';
import Minolta13 from './components/Minolta/MinoltaToneri/Minolta13';
import Minolta14 from './components/Minolta/MinoltaToneri/Minolta14';

import Xerox1 from './components/Xerox/XeroxToneri/Xerox1'
import Xerox2 from './components/Xerox/XeroxToneri/Xerox2'
import Xerox3 from './components/Xerox/XeroxToneri/Xerox3'
import Xerox4 from './components/Xerox/XeroxToneri/Xerox4'
import Xerox5 from './components/Xerox/XeroxToneri/Xerox5'
import Xerox6 from './components/Xerox/XeroxToneri/Xerox6'
import Xerox7 from './components/Xerox/XeroxToneri/Xerox7'
import Xerox8 from './components/Xerox/XeroxToneri/Xerox8'
import Xerox9 from './components/Xerox/XeroxToneri/Xerox9'
import Xerox10 from './components/Xerox/XeroxToneri/Xerox10'
import Xerox11 from './components/Xerox/XeroxToneri/Xerox11'
import Xerox12 from './components/Xerox/XeroxToneri/Xerox12'
import Xerox13 from './components/Xerox/XeroxToneri/Xerox13'
import Xerox14 from './components/Xerox/XeroxToneri/Xerox14'
import Xerox15 from './components/Xerox/XeroxToneri/Xerox15'

import Lexmark1 from './components/Lexmark/LexmarkToneri/Lexmark1';
import Lexmark2 from './components/Lexmark/LexmarkToneri/Lexmark2';
import Lexmark3 from './components/Lexmark/LexmarkToneri/Lexmark3';
import Lexmark4 from './components/Lexmark/LexmarkToneri/Lexmark4';
import Lexmark5 from './components/Lexmark/LexmarkToneri/Lexmark5';
import Lexmark6 from './components/Lexmark/LexmarkToneri/Lexmark6';
import Lexmark7 from './components/Lexmark/LexmarkToneri/Lexmark7';
import Lexmark8 from './components/Lexmark/LexmarkToneri/Lexmark8';
import Lexmark9 from './components/Lexmark/LexmarkToneri/Lexmark9';
import Lexmark10 from './components/Lexmark/LexmarkToneri/Lexmark10';
import Lexmark11 from './components/Lexmark/LexmarkToneri/Lexmark11';
import Lexmark12 from './components/Lexmark/LexmarkToneri/Lexmark12';
import Lexmark13 from './components/Lexmark/LexmarkToneri/Lexmark13';
import Lexmark14 from './components/Lexmark/LexmarkToneri/Lexmark14';
import Lexmark15 from './components/Lexmark/LexmarkToneri/Lexmark15';
import Lexmark16 from './components/Lexmark/LexmarkToneri/Lexmark16';
import Lexmark17 from './components/Lexmark/LexmarkToneri/Lexmark17';
import Lexmark18 from './components/Lexmark/LexmarkToneri/Lexmark18';
import Lexmark19 from './components/Lexmark/LexmarkToneri/Lexmark19';
import Lexmark20 from './components/Lexmark/LexmarkToneri/Lexmark20';
import Lexmark21 from './components/Lexmark/LexmarkToneri/Lexmark21';

import Kyocera1 from './components/Kyocera/KyoceraPrinteri/Kyocera1';
import Kyocera2 from './components/Kyocera/KyoceraPrinteri/Kyocera2';
import Kyocera3 from './components/Kyocera/KyoceraPrinteri/Kyocera3';
import Kyocera4 from './components/Kyocera/KyoceraPrinteri/Kyocera4';
import Kyocera5 from './components/Kyocera/KyoceraPrinteri/Kyocera5';
import Kyocera6 from './components/Kyocera/KyoceraPrinteri/Kyocera6';
import Kyocera7 from './components/Kyocera/KyoceraPrinteri/Kyocera7';
import Kyocera8 from './components/Kyocera/KyoceraPrinteri/Kyocera8';
import Kyocera9 from './components/Kyocera/KyoceraPrinteri/Kyocera9';
import Kyocera10 from './components/Kyocera/KyoceraPrinteri/Kyocera10';
import Kyocera11 from './components/Kyocera/KyoceraPrinteri/Kyocera11';
import Kyocera12 from './components/Kyocera/KyoceraPrinteri/Kyocera12';
import Kyocera13 from './components/Kyocera/KyoceraPrinteri/Kyocera13';
import Kyocera14 from './components/Kyocera/KyoceraPrinteri/Kyocera14';
import Kyocera15 from './components/Kyocera/KyoceraPrinteri/Kyocera15';
import Kyocera16 from './components/Kyocera/KyoceraPrinteri/Kyocera16';
import Kyocera17 from './components/Kyocera/KyoceraPrinteri/Kyocera17';
import Kyocera18 from './components/Kyocera/KyoceraPrinteri/Kyocera18';
import Kyocera19 from './components/Kyocera/KyoceraPrinteri/Kyocera19';
import Kyocera20 from './components/Kyocera/KyoceraPrinteri/Kyocera20';
import Kyocera21 from './components/Kyocera/KyoceraPrinteri/Kyocera21';
import Kyocera22 from './components/Kyocera/KyoceraPrinteri/Kyocera22';
import Kyocera23 from './components/Kyocera/KyoceraPrinteri/Kyocera23';
import Kyocera24 from './components/Kyocera/KyoceraPrinteri/Kyocera24';
import Kyocera25 from './components/Kyocera/KyoceraPrinteri/Kyocera25';
import Kyocera26 from './components/Kyocera/KyoceraPrinteri/Kyocera26';
import Kyocera27 from './components/Kyocera/KyoceraPrinteri/Kyocera27';
import Kyocera28 from './components/Kyocera/KyoceraPrinteri/Kyocera28';
import Kyocera29 from './components/Kyocera/KyoceraPrinteri/Kyocera29';
import Kyocera30 from './components/Kyocera/KyoceraPrinteri/Kyocera30';
import Kyocera31 from './components/Kyocera/KyoceraPrinteri/Kyocera31';

import Samsung1 from './components/Samsung/SamsungToneri/Samsung1';
import Samsung2 from './components/Samsung/SamsungToneri/Samsung2';
import Samsung3 from './components/Samsung/SamsungToneri/Samsung3';
import Samsung4 from './components/Samsung/SamsungToneri/Samsung4';
import Samsung5 from './components/Samsung/SamsungToneri/Samsung5';
import Samsung6 from './components/Samsung/SamsungToneri/Samsung6';
import Samsung7 from './components/Samsung/SamsungToneri/Samsung7';
import Samsung8 from './components/Samsung/SamsungToneri/Samsung8';
import Samsung9 from './components/Samsung/SamsungToneri/Samsung9';
import Samsung10 from './components/Samsung/SamsungToneri/Samsung10';
import Samsung11 from './components/Samsung/SamsungToneri/Samsung11';
import Samsung12 from './components/Samsung/SamsungToneri/Samsung12';
import Samsung13 from './components/Samsung/SamsungToneri/Samsung13';
import Samsung14 from './components/Samsung/SamsungToneri/Samsung14';
import Samsung15 from './components/Samsung/SamsungToneri/Samsung15';
import Samsung16 from './components/Samsung/SamsungToneri/Samsung16';
import Samsung17 from './components/Samsung/SamsungToneri/Samsung17';
import Samsung18 from './components/Samsung/SamsungToneri/Samsung18';
import Samsung19 from './components/Samsung/SamsungToneri/Samsung19';
import Samsung20 from './components/Samsung/SamsungToneri/Samsung20';
import Samsung21 from './components/Samsung/SamsungToneri/Samsung21';
import Samsung22 from './components/Samsung/SamsungToneri/Samsung22';
import Samsung23 from './components/Samsung/SamsungToneri/Samsung23';
import Samsung24 from './components/Samsung/SamsungToneri/Samsung24';
import Samsung25 from './components/Samsung/SamsungToneri/Samsung25';
import Samsung26 from './components/Samsung/SamsungToneri/Samsung26';
import Samsung27 from './components/Samsung/SamsungToneri/Samsung27';
import Samsung28 from './components/Samsung/SamsungToneri/Samsung28';
import Samsung29 from './components/Samsung/SamsungToneri/Samsung29';
import Samsung30 from './components/Samsung/SamsungToneri/Samsung30';
import Samsung31 from './components/Samsung/SamsungToneri/Samsung31';
import Samsung32 from './components/Samsung/SamsungToneri/Samsung32';
import Samsung33 from './components/Samsung/SamsungToneri/Samsung33';
import Samsung34 from './components/Samsung/SamsungToneri/Samsung34';
import Samsung35 from './components/Samsung/SamsungToneri/Samsung35';
import Samsung36 from './components/Samsung/SamsungToneri/Samsung36';
import Samsung37 from './components/Samsung/SamsungToneri/Samsung37';

import HP1 from './components/HP/HPToneri/HP1'
import HP2 from './components/HP/HPToneri/HP2'
import HP3 from './components/HP/HPToneri/HP3'
import HP4 from './components/HP/HPToneri/HP4'
import HP5 from './components/HP/HPToneri/HP5'
import HP6 from './components/HP/HPToneri/HP6'
import HP7 from './components/HP/HPToneri/HP7'
import HP8 from './components/HP/HPToneri/HP8'
import HP9 from './components/HP/HPToneri/HP9'
import HP10 from './components/HP/HPToneri/HP10'
import HP11 from './components/HP/HPToneri/HP11'
import HP12 from './components/HP/HPToneri/HP12'
import HP13 from './components/HP/HPToneri/HP13'
import HP14 from './components/HP/HPToneri/HP14'
import HP15 from './components/HP/HPToneri/HP15'
import HP16 from './components/HP/HPToneri/HP16'
import HP17 from './components/HP/HPToneri/HP17'
import HP18 from './components/HP/HPToneri/HP18'
import HP19 from './components/HP/HPToneri/HP19'
import HP20 from './components/HP/HPToneri/HP20'
import HP21 from './components/HP/HPToneri/HP21'
import HP22 from './components/HP/HPToneri/HP22'
import HP23 from './components/HP/HPToneri/HP23'
import HP24 from './components/HP/HPToneri/HP24'
import HP25 from './components/HP/HPToneri/HP25'
import HP26 from './components/HP/HPToneri/HP26'
import HP27 from './components/HP/HPToneri/HP27'
import HP28 from './components/HP/HPToneri/HP28'
import HP29 from './components/HP/HPToneri/HP29'
import HP30 from './components/HP/HPToneri/HP30'
import HP31 from './components/HP/HPToneri/HP31'
import HP32 from './components/HP/HPToneri/HP32'
import HP33 from './components/HP/HPToneri/HP33'
import HP34 from './components/HP/HPToneri/HP34'
import HP35 from './components/HP/HPToneri/HP35'
import HP36 from './components/HP/HPToneri/HP36'
import HP37 from './components/HP/HPToneri/HP37'
import HP38 from './components/HP/HPToneri/HP38'
import HP39 from './components/HP/HPToneri/HP39'
import HP40 from './components/HP/HPToneri/HP40'
import HP41 from './components/HP/HPToneri/HP41'
import HP42 from './components/HP/HPToneri/HP42'
import HP43 from './components/HP/HPToneri/HP43'
import HP44 from './components/HP/HPToneri/HP44'
import HP45 from './components/HP/HPToneri/HP45'
import HP46 from './components/HP/HPToneri/HP46'
import HP47 from './components/HP/HPToneri/HP47'
import HP48 from './components/HP/HPToneri/HP48'
import HP49 from './components/HP/HPToneri/HP49'
import HP50 from './components/HP/HPToneri/HP50'
import HP51 from './components/HP/HPToneri/HP51'
import HP52 from './components/HP/HPToneri/HP52'
import HP53 from './components/HP/HPToneri/HP53'
import HP54 from './components/HP/HPToneri/HP54'
import HP55 from './components/HP/HPToneri/HP55'
import HP56 from './components/HP/HPToneri/HP56'
import HP57 from './components/HP/HPToneri/HP57'
import HP58 from './components/HP/HPToneri/HP58'
import HP59 from './components/HP/HPToneri/HP59'
import HP60 from './components/HP/HPToneri/HP60'
import HP61 from './components/HP/HPToneri/HP61'
import HP62 from './components/HP/HPToneri/HP62'
import HP63 from './components/HP/HPToneri/HP63'
import HP64 from './components/HP/HPToneri/HP64'
import HP65 from './components/HP/HPToneri/HP65'
import HP66 from './components/HP/HPToneri/HP66'
import HP67 from './components/HP/HPToneri/HP67'
import HP68 from './components/HP/HPToneri/HP68'
import HP69 from './components/HP/HPToneri/HP69'
import HP70 from './components/HP/HPToneri/HP70'
import HP71 from './components/HP/HPToneri/HP71'
import HP72 from './components/HP/HPToneri/HP72'
import HP73 from './components/HP/HPToneri/HP73'
import HP74 from './components/HP/HPToneri/HP74'
import HP75 from './components/HP/HPToneri/HP75'
import HP76 from './components/HP/HPToneri/HP76'
import HP77 from './components/HP/HPToneri/HP77'
import HP78 from './components/HP/HPToneri/HP78'
import Kyocera32 from './components/Kyocera/KyoceraPrinteri/Kyocera32';
import Kontakt from './pages/Kontakt';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/ostali" element={<Brendovi /> } />
        
        <Route path="/kontakt" element={ <Kontakt /> } />

        <Route path="/hp" element={ <HP /> } />
        <Route path="/hp/1" element={ <HP1 /> } />
        <Route path="/hp/2" element={ <HP2 /> } />
        <Route path="/hp/3" element={ <HP3 /> } />
        <Route path="/hp/4" element={ <HP4 /> } />
        <Route path="/hp/5" element={ <HP5 /> } />
        <Route path="/hp/6" element={ <HP6 /> } />
        <Route path="/hp/7" element={ <HP7 /> } />
        <Route path="/hp/8" element={ <HP8 /> } />
        <Route path="/hp/9" element={ <HP9 /> } />
        <Route path="/hp/10" element={ <HP10 /> } />
        <Route path="/hp/11" element={ <HP11 /> } />
        <Route path="/hp/12" element={ <HP12 /> } />
        <Route path="/hp/13" element={ <HP13 /> } />
        <Route path="/hp/14" element={ <HP14 /> } />
        <Route path="/hp/15" element={ <HP15 /> } />
        <Route path="/hp/16" element={ <HP16 /> } />
        <Route path="/hp/17" element={ <HP17 /> } />
        <Route path="/hp/18" element={ <HP18 /> } />
        <Route path="/hp/19" element={ <HP19 /> } />
        <Route path="/hp/20" element={ <HP20 /> } />
        <Route path="/hp/21" element={ <HP21 /> } />
        <Route path="/hp/22" element={ <HP22 /> } />
        <Route path="/hp/23" element={ <HP23 /> } />
        <Route path="/hp/24" element={ <HP24 /> } />
        <Route path="/hp/25" element={ <HP25 /> } />
        <Route path="/hp/26" element={ <HP26 /> } />
        <Route path="/hp/27" element={ <HP27 /> } />
        <Route path="/hp/28" element={ <HP28 /> } />
        <Route path="/hp/29" element={ <HP29 /> } />
        <Route path="/hp/30" element={ <HP30 /> } />
        <Route path="/hp/31" element={ <HP31 /> } />
        <Route path="/hp/32" element={ <HP32 /> } />
        <Route path="/hp/33" element={ <HP33 /> } />
        <Route path="/hp/34" element={ <HP34 /> } />
        <Route path="/hp/35" element={ <HP35 /> } />
        <Route path="/hp/36" element={ <HP36 /> } />
        <Route path="/hp/37" element={ <HP37 /> } />
        <Route path="/hp/38" element={ <HP38 /> } />
        <Route path="/hp/39" element={ <HP39 /> } />
        <Route path="/hp/40" element={ <HP40 /> } />
        <Route path="/hp/41" element={ <HP41 /> } />
        <Route path="/hp/42" element={ <HP42 /> } />
        <Route path="/hp/43" element={ <HP43 /> } />
        <Route path="/hp/44" element={ <HP44 /> } />
        <Route path="/hp/45" element={ <HP45 /> } />
        <Route path="/hp/46" element={ <HP46 /> } />
        <Route path="/hp/47" element={ <HP47 /> } />
        <Route path="/hp/48" element={ <HP48 /> } />
        <Route path="/hp/49" element={ <HP49 /> } />
        <Route path="/hp/50" element={ <HP50 /> } />
        <Route path="/hp/51" element={ <HP51 /> } />
        <Route path="/hp/52" element={ <HP52 /> } />
        <Route path="/hp/53" element={ <HP53 /> } />
        <Route path="/hp/54" element={ <HP54 /> } />
        <Route path="/hp/55" element={ <HP55 /> } />
        <Route path="/hp/56" element={ <HP56 /> } />
        <Route path="/hp/57" element={ <HP57 /> } />
        <Route path="/hp/58" element={ <HP58 /> } />
        <Route path="/hp/59" element={ <HP59 /> } />
        <Route path="/hp/60" element={ <HP60 /> } />
        <Route path="/hp/61" element={ <HP61 /> } />
        <Route path="/hp/62" element={ <HP62 /> } />
        <Route path="/hp/63" element={ <HP63 /> } />
        <Route path="/hp/64" element={ <HP64 /> } />
        <Route path="/hp/65" element={ <HP65 /> } />
        <Route path="/hp/66" element={ <HP66 /> } />
        <Route path="/hp/67" element={ <HP67 /> } />
        <Route path="/hp/68" element={ <HP68 /> } />
        <Route path="/hp/69" element={ <HP69 /> } />
        <Route path="/hp/70" element={ <HP70 /> } />
        <Route path="/hp/71" element={ <HP71 /> } />
        <Route path="/hp/72" element={ <HP72 /> } />
        <Route path="/hp/73" element={ <HP73 /> } />
        <Route path="/hp/74" element={ <HP74 /> } />
        <Route path="/hp/75" element={ <HP75 /> } />
        <Route path="/hp/76" element={ <HP76 /> } />
        <Route path="/hp/77" element={ <HP77 /> } />
        <Route path="/hp/78" element={ <HP78 /> } />


        <Route path="/kyocera" element={ <Kyocera /> } />
        <Route path="/kyocera/1" element={ <Kyocera1 /> } />
        <Route path="/kyocera/2" element={ <Kyocera2 /> } />
        <Route path="/kyocera/3" element={ <Kyocera3 /> } />
        <Route path="/kyocera/4" element={ <Kyocera4 /> } />
        <Route path="/kyocera/5" element={ <Kyocera5 /> } />
        <Route path="/kyocera/6" element={ <Kyocera6 /> } />
        <Route path="/kyocera/7" element={ <Kyocera7 /> } />
        <Route path="/kyocera/8" element={ <Kyocera8 /> } />
        <Route path="/kyocera/9" element={ <Kyocera9 /> } />
        <Route path="/kyocera/10" element={ <Kyocera10 /> } />
        <Route path="/kyocera/11" element={ <Kyocera11 /> } />
        <Route path="/kyocera/12" element={ <Kyocera12/> } />
        <Route path="/kyocera/13" element={ <Kyocera13 /> } />
        <Route path="/kyocera/14" element={ <Kyocera14 /> } />
        <Route path="/kyocera/15" element={ <Kyocera15 /> } />
        <Route path="/kyocera/16" element={ <Kyocera16 /> } />
        <Route path="/kyocera/17" element={ <Kyocera17 /> } />
        <Route path="/kyocera/18" element={ <Kyocera18 /> } />
        <Route path="/kyocera/19" element={ <Kyocera19 /> } />
        <Route path="/kyocera/20" element={ <Kyocera20 /> } />
        <Route path="/kyocera/21" element={ <Kyocera21 /> } />
        <Route path="/kyocera/22" element={ <Kyocera22 /> } />
        <Route path="/kyocera/23" element={ <Kyocera23 /> } />
        <Route path="/kyocera/24" element={ <Kyocera24 /> } />
        <Route path="/kyocera/25" element={ <Kyocera25 /> } />
        <Route path="/kyocera/26" element={ <Kyocera26 /> } />
        <Route path="/kyocera/27" element={ <Kyocera27 /> } />
        <Route path="/kyocera/28" element={ <Kyocera28 /> } />
        <Route path="/kyocera/29" element={ <Kyocera29 /> } />
        <Route path="/kyocera/30" element={ <Kyocera30 /> } />
        <Route path="/kyocera/31" element={ <Kyocera31 /> } />
        <Route path="/kyocera/32" element={ <Kyocera32 /> } />

        <Route path="/samsung" element={ <Samsung /> } />
        <Route path="/samsung/1" element={ <Samsung1 /> } />
        <Route path="/samsung/2" element={ <Samsung2 /> } />
        <Route path="/samsung/3" element={ <Samsung3 /> } />
        <Route path="/samsung/4" element={ <Samsung4 /> } />
        <Route path="/samsung/5" element={ <Samsung5 /> } />
        <Route path="/samsung/6" element={ <Samsung6 /> } />
        <Route path="/samsung/7" element={ <Samsung7 /> } />
        <Route path="/samsung/8" element={ <Samsung8 /> } />
        <Route path="/samsung/9" element={ <Samsung9 /> } />
        <Route path="/samsung/10" element={ <Samsung10 /> } />
        <Route path="/samsung/11" element={ <Samsung11 /> } />
        <Route path="/samsung/12" element={ <Samsung12 /> } />
        <Route path="/samsung/13" element={ <Samsung13 /> } />
        <Route path="/samsung/14" element={ <Samsung14 /> } />
        <Route path="/samsung/15" element={ <Samsung15 /> } />
        <Route path="/samsung/16" element={ <Samsung16 /> } />
        <Route path="/samsung/17" element={ <Samsung17 /> } />
        <Route path="/samsung/18" element={ <Samsung18 /> } />
        <Route path="/samsung/19" element={ <Samsung19 /> } />
        <Route path="/samsung/20" element={ <Samsung20 /> } />
        <Route path="/samsung/21" element={ <Samsung21 /> } />
        <Route path="/samsung/22" element={ <Samsung22 /> } />
        <Route path="/samsung/23" element={ <Samsung23 /> } />
        <Route path="/samsung/24" element={ <Samsung24 /> } />
        <Route path="/samsung/25" element={ <Samsung25 /> } />
        <Route path="/samsung/26" element={ <Samsung26 /> } />
        <Route path="/samsung/27" element={ <Samsung27 /> } />
        <Route path="/samsung/28" element={ <Samsung28 /> } />
        <Route path="/samsung/29" element={ <Samsung29 /> } />
        <Route path="/samsung/30" element={ <Samsung30 /> } />
        <Route path="/samsung/31" element={ <Samsung31 /> } />
        <Route path="/samsung/32" element={ <Samsung32 /> } />
        <Route path="/samsung/33" element={ <Samsung33 /> } />
        <Route path="/samsung/34" element={ <Samsung34 /> } />
        <Route path="/samsung/35" element={ <Samsung35 /> } />
        <Route path="/samsung/36" element={ <Samsung36 /> } />
        <Route path="/samsung/37" element={ <Samsung37 /> } />

        <Route path="/lexmark" element={ <Lexmark /> } />
        <Route path="/lexmark/1" element={ <Lexmark1 /> } />
        <Route path="/lexmark/2" element={ <Lexmark2 /> } />
        <Route path="/lexmark/3" element={ <Lexmark3 /> } />
        <Route path="/lexmark/4" element={ <Lexmark4 /> } />
        <Route path="/lexmark/5" element={ <Lexmark5 /> } />
        <Route path="/lexmark/6" element={ <Lexmark6 /> } />
        <Route path="/lexmark/7" element={ <Lexmark7 /> } />
        <Route path="/lexmark/8" element={ <Lexmark8 /> } />
        <Route path="/lexmark/9" element={ <Lexmark9 /> } />
        <Route path="/lexmark/10" element={ <Lexmark10 /> } />
        <Route path="/lexmark/11" element={ <Lexmark11 /> } />
        <Route path="/lexmark/12" element={ <Lexmark12 /> } />
        <Route path="/lexmark/13" element={ <Lexmark13 /> } />
        <Route path="/lexmark/14" element={ <Lexmark14 /> } />
        <Route path="/lexmark/15" element={ <Lexmark15 /> } />
        <Route path="/lexmark/16" element={ <Lexmark16 /> } />
        <Route path="/lexmark/17" element={ <Lexmark17 /> } />
        <Route path="/lexmark/18" element={ <Lexmark18 /> } />
        <Route path="/lexmark/19" element={ <Lexmark19 /> } />
        <Route path="/lexmark/20" element={ <Lexmark20 /> } />
        <Route path="/lexmark/21" element={ <Lexmark21 /> } />

        <Route path="/xerox" element={ <Xerox /> } />
        <Route path="/xerox/1" element={ <Xerox1 /> } />
        <Route path="/xerox/2" element={ <Xerox2 /> } />
        <Route path="/xerox/3" element={ <Xerox3 /> } />
        <Route path="/xerox/4" element={ <Xerox4 /> } />
        <Route path="/xerox/5" element={ <Xerox5 /> } />
        <Route path="/xerox/6" element={ <Xerox6 /> } />
        <Route path="/xerox/7" element={ <Xerox7 /> } />
        <Route path="/xerox/8" element={ <Xerox8 /> } />
        <Route path="/xerox/9" element={ <Xerox9 /> } />
        <Route path="/xerox/10" element={ <Xerox10 /> } />
        <Route path="/xerox/11" element={ <Xerox11 /> } />
        <Route path="/xerox/12" element={ <Xerox12 /> } />
        <Route path="/xerox/13" element={ <Xerox13 /> } />
        <Route path="/xerox/14" element={ <Xerox14 /> } />
        <Route path="/xerox/15" element={ <Xerox15 /> } />

        <Route path="/minolta" element={ <Minolta /> } />
        <Route path="/minolta/1" element={ <Minolta1 /> } />
        <Route path="/minolta/2" element={ <Minolta2 /> } />
        <Route path="/minolta/3" element={ <Minolta3 /> } />
        <Route path="/minolta/4" element={ <Minolta4 /> } />
        <Route path="/minolta/5" element={ <Minolta5 /> } />
        <Route path="/minolta/6" element={ <Minolta6 /> } />
        <Route path="/minolta/7" element={ <Minolta7 /> } />
        <Route path="/minolta/8" element={ <Minolta8 /> } />
        <Route path="/minolta/9" element={ <Minolta9 /> } />
        <Route path="/minolta/10" element={ <Minolta10 /> } />
        <Route path="/minolta/11" element={ <Minolta11 /> } />
        <Route path="/minolta/12" element={ <Minolta12 /> } />
        <Route path="/minolta/13" element={ <Minolta13 /> } />
        <Route path="/minolta/14" element={ <Minolta14 /> } />


        <Route path="/epson" element={ <Epson /> } />
        <Route path="/epson/1" element={ <Epson1 /> } />
        <Route path="/epson/2" element={ <Epson2 /> } />
        <Route path="/epson/3" element={ <Epson3 /> } />
        <Route path="/epson/4" element={ <Epson4 /> } />
        <Route path="/epson/5" element={ <Epson5 /> } />
        <Route path="/epson/6" element={ <Epson6 /> } />
 
        <Route path="/brother" element={ <Brother /> } />
        <Route path="/brother/1" element={ <Brother1 /> } />
        <Route path="/brother/2" element={ <Brother2 /> } />
        <Route path="/brother/3" element={ <Brother3 /> } />
        <Route path="/brother/4" element={ <Brother4 />} />
        <Route path="/brother/5" element={ <Brother5 /> } />
        <Route path="/brother/6" element={ <Brother6 /> } />
        <Route path="/brother/7" element={ <Brother7 /> } />
        <Route path="/brother/8" element={ <Brother8 /> } />
        <Route path="/brother/9" element={ <Brother9 /> } />
        <Route path="/brother/10" element={ <Brother10  /> } /> 
        <Route path="/brother/11" element={ <Brother11 /> } />
        <Route path="/brother/12" element={ <Brother12  /> } /> 
        <Route path="/brother/13" element={ <Brother13  /> } /> 
        <Route path="/brother/14" element={ <Brother14 /> } />
        <Route path="/brother/15" element={ <Brother15  /> } />
        <Route path="/brother/16" element={ <Brother16  /> } /> 
        <Route path="/brother/17" element={ <Brother17 /> } />
        <Route path="/brother/18" element={ <Brother18  /> } /> 
        <Route path="/brother/19" element={ <Brother19  /> } /> 
        <Route path="/brother/20" element={ <Brother20 /> } />
        <Route path="/brother/21" element={ <Brother21  /> } />
        <Route path="/brother/22" element={ <Brother22 /> } />
        <Route path="/brother/23" element={ <Brother23 /> } />
        <Route path="/brother/24" element={ <Brother24 /> } />
        <Route path="/brother/25" element={ <Brother25 /> } />
        <Route path="/brother/26" element={ <Brother26 /> } />
        <Route path="/brother/27" element={ <Brother27 /> } />
        <Route path="/brother/28" element={ <Brother28 /> } />
        <Route path="/brother/29" element={ <Brother29 /> } />
        <Route path="/brother/30" element={ <Brother30 /> } />
        <Route path="/brother/31" element={ <Brother31 /> } />
        

        <Route path="/panasonic" element={ <Panasonic /> } />
        <Route path="/panasonic/1" element={ <Panasonic1 /> } />
        <Route path="/panasonic/2" element={ <Panasonic2 /> } />
        <Route path="/panasonic/3" element={ <Panasonic3 /> } />
        <Route path="/panasonic/4" element={ <Panasonic4 /> } />
        <Route path="/panasonic/5" element={ <Panasonic5 /> } />
        <Route path="/panasonic/6" element={ <Panasonic6 /> } />
        <Route path="/panasonic/7" element={ <Panasonic7 /> } />
        <Route path="/panasonic/8" element={ <Panasonic8 /> } />
        <Route path="/panasonic/9" element={ <Panasonic9 /> } />
        <Route path="/panasonic/10" element={ <Panasonic10 /> } />
        <Route path="/panasonic/11" element={ <Panasonic11 /> } />

        <Route path="/canon" element={ <Canon /> } />
        <Route path="/canon/ef_37" element={ <EF_37 /> }/>
        <Route path="/canon/FX_10" element={ <FX_10 /> } />
        <Route path="/canon/CRG-039H" element={ <Canon3 /> } />
        <Route path="/canon/CRG-041" element={ <Canon4 /> } />
        <Route path="/canon/CRG-052" element={ <Canon5 /> } />
        <Route path="/canon/CRG-040" element={ <Canon6 /> } />
        <Route path="/canon/CRG-054-BK" element={ <Canon7 /> } />
        <Route path="/canon/CRG-054-MG" element={ <Canon8 /> } />
        <Route path="/canon/CRG-054-YL" element={ <Canon9 /> } />  
        <Route path="/canon/CRG-054-CY" element={ <Canon10 /> } />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
